(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("moment"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "moment", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["chokhmah"] = factory(require("react"), require("moment"), require("react-dom"));
	else
		root["chokhmah"] = factory(root["react"], root["moment"], root["react-dom"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_moment__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition